import styles from './CustomHeroProgramSlider.module.scss';
import ProgramCards from '@/components/molecules/Carousels/HeroSlideRevamp/HeroProgramSectionSliders/ProgramCards';
import UnivoLink from '@/components/common/UnivoLink';
import { MOBILE_BRAND_LCP } from '@/constants/images';

/**
 * Mobile LCP is the Amity Brand collage.
 * Use a raw <img> with the CDN URL (never /_next/image) so the homepage
 * preload href matches the painted element — same contract as DesktopHeroLcpImage.
 */
export default function CustomHeroProgramSlider({ sliderData }: { sliderData: any }) {
  const { src, width, height } = MOBILE_BRAND_LCP;

  return (
    <div className={styles.gridImageWrapper}>
      <div className={styles.amityBrand}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={src}
          alt="Amity Brand"
          width={width}
          height={height}
         // style={{ objectFit: "cover" }}
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </div>
    
      <div className={styles.gridContainer}>
        {sliderData?.map((item, index: number) => (
          <UnivoLink
            href={item?.slug?.trim() || "/"}
            className={styles.card_link}
            key={index}
            id={`banner-program-${item.id}`}
          >
            <ProgramCards
              programName={item?.Title}
              subText={item?.SubTitle}
              imgSrc={item?.Image}
              slug={item?.slug?.trim()}
              isLazy={index >= 3}
              isLcp={false}
            />
          </UnivoLink>
        ))}
      </div>
    </div>
  );
}
